function hasPricingObject(activity) {
  return activity.pricing && Object.keys(activity.pricing).length > 0;
}

function hasRegularPrice(activity) {
  return hasPricingObject(activity) && activity.pricing.regular_price &&
    Object.keys(activity.pricing.regular_price).length > 0;
}

function hasDiscountedPrice(activity) {
  return hasPricingObject(activity) && activity.pricing.discounted_price &&
    Object.keys(activity.pricing.discounted_price).length > 0;
}

function getPartnerActivityPrice(activity) {
  if (hasPricingObject(activity) && hasRegularPrice(activity)) {
    return activity.pricing.regular_price.amount;
  } else if (hasPricingObject(activity) && hasDiscountedPrice(activity)) {
    return activity.pricing.discounted_price.amount;
  }

  return "";
}

function getPartnerActivityDiscountedPrice(activity) {
  if (hasPricingObject(activity) && hasRegularPrice(activity) && hasDiscountedPrice(activity)) {
    return activity.pricing.discounted_price.amount;
  }

  return "";
}

function getPartnerActivityCurrency(activity) {
  if (hasPricingObject(activity) && hasRegularPrice(activity)) {
    return activity.pricing.regular_price.currency;
  } else if (hasPricingObject(activity) && hasDiscountedPrice(activity)) {
    return activity.pricing.discounted_price.currency;
  }

  return "";
}

export {
  getPartnerActivityPrice,
  getPartnerActivityDiscountedPrice,
  getPartnerActivityCurrency,
};



// WEBPACK FOOTER //
// ./assets/pois/utils/partnerActivityPricing.js